import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/home';

export default function LatestNews() {
  return (
    <section className="w-full py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">最新资讯</h2>
            <p className="text-foreground-600 text-sm">游戏攻略、活动公告、行业动态一手掌握</p>
          </div>
          <Link
            to="/category/all?tab=articles"
            className="inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            更多资讯
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestArticles.slice(0, 6).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-xl bg-background-100 border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-2.5 left-2.5">
                  <span className="inline-block px-2.5 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2 mb-3">{article.excerpt}</p>
                <div className="flex items-center justify-between text-foreground-500 text-xs">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {article.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {(article.views / 10000).toFixed(1)}万
                    </span>
                  </div>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}